import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { Confetti } from '../../models/confetti';
import { randomRange } from '../../utils/math';

@Component({
  selector: 'confetti-effect',
  templateUrl: './confetti-effect.component.html',
  styleUrls: ['./confetti-effect.component.css'],
  standalone: false
})

// the logic below to render the confetti animation has been
// forked from https://codepen.io/coopergoeke/pen/wvaYMbJ
export class ConfettiEffectComponent implements AfterViewInit {
  @ViewChild('canvas', { static: false }) canvas: ElementRef;

  public context: CanvasRenderingContext2D;

  // amount to add on each button press
  public count = 50;

  // "physics" variables
  public gravity = 0.3;
  public drag = 0.05; //0.075;
  public terminalVelocity = 3;

  // add Confetti objects to arrays to draw them
  public confetti = [];

  // colors, back side is darker for confetti flipping
  public colors = [
    { front: '#6AAA37', back: '#4a7826' }, // green
    { front: '#d4d41c', back: '#c7c74c' } // gold
  ];

  ngAfterViewInit(): void {
    this.context = this.canvas.nativeElement.getContext('2d');
    this._draw();
  }

  private _draw() {
    const c = this.canvas.nativeElement as HTMLCanvasElement;

    c.width = c.parentElement.parentElement.offsetWidth;
    c.height = c.parentElement.parentElement.offsetHeight;

    this.initBurst();
    this.render();
  }

  // add elements to arrays to be drawn
  private initBurst = () => {
    for (let i = 0; i < this.count; i++) {
      this.confetti.push(
        new Confetti(
          this.colors,
          this.canvas.nativeElement as HTMLCanvasElement,
          this._initConfettiVelocity
        )
      );
    }
  };

  // helper function to get initial velocities for confetti
  // this weighted spread helps the confetti look more realistic
  private _initConfettiVelocity(xRange, yRange) {
    const x = randomRange(xRange[0], xRange[1]);
    const range = yRange[1] - yRange[0] + 1;
    let y = yRange[1] - Math.abs(randomRange(0, range) + randomRange(0, range) - range);
    if (y >= yRange[1] - 1) {
      // Occasional confetti goes higher than the max
      y += Math.random() < 0.25 ? randomRange(1, 3) : 0;
    }
    return { x: x, y: -y };
  }

  // draws the elements on the canvas
  public render() {
    const canvas = this.canvas.nativeElement as HTMLCanvasElement;

    this.context.clearRect(0, 0, canvas.width, canvas.height);

    this.confetti.forEach((confetti: Confetti, index) => {
      let width = confetti.dimensions.x * confetti.scale.x;
      let height = confetti.dimensions.y * confetti.scale.y;

      // move canvas to position and rotate
      this.context.translate(confetti.position.x, confetti.position.y);
      this.context.rotate(confetti.rotation);

      // update confetti "physics" values
      confetti.update(this.drag, this.gravity, this.terminalVelocity);

      // get front or back fill color
      this.context.fillStyle = confetti.scale.y > 0 ? confetti.color.front : confetti.color.back;

      // draw confetti
      this.context.fillRect(-width / 2, -height / 2, width, height);

      // reset transform matrix
      this.context.setTransform(1, 0, 0, 1, 0, 0);

      // // clear rectangle where button cuts off
      // if (confetti.velocity.y < 0) {
      //   this.context.clearRect(canvas.width/2, canvas.height/2, button.offsetWidth, button.offsetHeight)
      // }
    });

    // remove confetti that falls off the screen
    // must be done in seperate loops to avoid noticeable flickering
    this.confetti.forEach((confetti: Confetti, index) => {
      if (confetti.position.y >= canvas.height) {
        this.confetti.splice(index, 1);
      }
    });

    window.requestAnimationFrame(() => {
      this.render();
    });
  }
}
